import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function PrivacyPolicy() {
  return (
    <div className="App">
      <nav className="navbar">
        <Link to="/" className="nav-logo-container">
          <img src={`${process.env.PUBLIC_URL}/logo_transparent.png`} className="nav-logo" alt="Redder Media Logo" />
        </Link>
        <div className="nav-items">
          <Link to="/" className="nav-item">Home</Link>
          <Link to="/#about" className="nav-item">About</Link>
          <Link to="/#projects" className="nav-item">Projects</Link>
        </div>
      </nav>

      <main className="main-content">
        <section className="privacy-page">
          <div className="privacy-content">
            <h1 className="privacy-title">A Virtue A Day — Privacy Policy</h1>
            <p className="privacy-updated">Last updated: February 3, 2025</p>

            <div className="privacy-section">
              <h2>Introduction</h2>
              <p>
                A Virtue A Day is a practice exercise tracker for developing virtues in a philosophic way and improving your overall life. It is built by Redder Media. This Privacy Policy explains how we collect, use, and protect your information when you use our app and related services.
              </p>
            </div>

            <div className="privacy-section">
              <h2>Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul>
                <li><strong>Account information:</strong> If you create an account, we may collect your email address and display name.</li>
                <li><strong>Practice and virtue data:</strong> Entries you create, such as progress notes, completed exercises, and completed virtues.</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve A Virtue A Day.</li>
                <li>Sync your data across your devices when you are signed in.</li>
                <li>Respond to support requests and communicate with you about the app.</li>
                <li>Analyze usage in an aggregated way to improve features and performance.</li>
                <li>Comply with applicable laws and protect our rights and users’ safety.</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>Data Storage and Security</h2>
              <p>
                We store your data using industry-standard security practices. Account and practice data are stored in secure, access-controlled environments. We do not sell your personal information to third parties.
              </p>
            </div>

            <div className="privacy-section">
              <h2>Data Sharing</h2>
              <p>
                We do not sell or rent your personal information. We may share data only (1) with service providers who help us operate the app under strict confidentiality, (2) when required by law or to protect rights and safety, or (3) with your consent.
              </p>
            </div>

            <div className="privacy-section">
              <h2>Your Rights</h2>
              <p>Depending on your location, you may have the right to:</p>
              <ul>
                <li>Access and receive a copy of your data.</li>
                <li>Correct or update your information.</li>
                <li>Request deletion of your account and associated data.</li>
                <li>Object to or restrict certain processing.</li>
                <li>Withdraw consent where processing is based on consent.</li>
              </ul>
              <p>To exercise these rights, contact us using the details below.</p>
            </div>

            <div className="privacy-section">
              <h2>Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will post the updated policy in the app or on our website and update the “Last updated” date. Continued use of the app after changes constitutes acceptance of the updated policy.
              </p>
            </div>

            <div className="privacy-section">
              <h2>Contact Us</h2>
              <p>
                For privacy-related questions or to exercise your rights, contact Redder Media at the contact methods provided on the Redder Media website or in the app.
              </p>
            </div>

            <Link to="/" className="privacy-back">← Back to Redder Media</Link>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© {new Date().getFullYear()} Redder Media. All Rights Reserved.</p>
      </footer>
    </div>
  );
}
